import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import React from "react";
import { Cancel, Delete, Edit } from "@mui/icons-material";
import CheckIcon from '@mui/icons-material/Check';
import { green, red } from "@mui/material/colors";
import { getQuestionMaster, updateQuestionMasterStatus, deleteQuestionMasterById, AddQuestionConfigReferanceMapping, UpdateReferenceBrokerId, AddorUpdateQuestionMaster } from "../../ApiSevices/QuestionConfigService";
import ConfirmationDialogComponent from "../../Common/ConfirmationDialogComponent";
import SnackBarComponent from "../../Common/SnackBarComponent";
import { GridTable } from "../../Sidebar/SidebarStyles";

interface IProps {
    displaysidebar: boolean;
}

interface IState {
    loading: boolean,
    datas: any[],
    copyData: any[],
    pageNo: number,
    pageSize: number,
    selectedBrokerId: number,
    totalRecords: number,
    brokerMaster: any[],
    referenceBrokerMaster: any[],
    isDialogOpen: boolean,
    dialogData: {
        isAdd: boolean,
        Id: number
        QuestionCode: string,
        LabelClassIds: string,
        FromAutos: string
    },
    snackBar: {
        message: string;
        severity: 'error' | 'warning' | 'info' | 'success';
        open: boolean;
        onClose: () => void
    },
    confirmationDialog: {
        isOpen: boolean,
        recordId: number,
        message: string,
        activate: boolean,
        isDelete?: boolean
    }
}

const columns: any[] = [
    { field: 'Id', headerName: 'Id', width: 70 },
    { field: 'QuestionCode', headerName: 'Question Code', width: 350 },
    { field: 'LabelClassIds', headerName: 'Label Class Ids', width: 350 },
    { field: 'FromAutos', headerName: 'From Autos', width: 350 },
    { field: 'IsActive', headerName: 'Status', width: 100 },
    { field: 'CreatedOn', headerName: 'CreatedOn', width: 100 },
    { field: 'Action', headerName: 'Action', width: 100 },
];

class QuestionMaster extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            loading: false,
            datas: [],
            copyData: [],
            pageNo: 1,
            pageSize: 1000,
            selectedBrokerId: 0,
            totalRecords: 0,
            brokerMaster: [],
            referenceBrokerMaster: [],
            isDialogOpen: false,
            dialogData: {
                Id: 0,
                isAdd: false,
                QuestionCode: "",
                LabelClassIds: "",
                FromAutos: ""
            },
            snackBar: {
                message: "",
                severity: 'success',
                open: false,
                onClose: () => { }
            },
            confirmationDialog: {
                isOpen: false,
                recordId: 0,
                message: "",
                activate: false
            }
        }
    }

    async componentDidMount(): Promise<void> {
        this.getData();
    }

    async getData(): Promise<void> {
        this.setState({ loading: true });
        try {
            const response = await getQuestionMaster();
            this.setState({
                datas: response || [],
                copyData: response || []
            });
        } catch (error) {
            console.error("Error in getData:", error);
        }
        finally {
            this.setState({ loading: false });
        }
    }

    handleDialogClose = () => {
        this.setState({
            isDialogOpen: false,
            dialogData: {
                isAdd: false,
                Id: 0,
                QuestionCode: "",
                FromAutos: "",
                LabelClassIds: ""
            }
        });
    };

    handleDialogConfirm = async (): Promise<void> => {
        this.setState({ loading: true });
        try {
            const { dialogData } = this.state;
            const body = {
                "Id": dialogData.Id !== 0 ? dialogData.Id : 0,
                "QuestionCode": dialogData.QuestionCode,
                "IsActive": true,
                "LabelClassIds": dialogData.LabelClassIds,
                "FromAutos": dialogData.FromAutos,
                "CreatedOn": new Date().toISOString(),
                "UpdatedOn": new Date().toISOString(),
                "CreatedBy": 0,
                "UpdatedBy": 0
            }
            await AddorUpdateQuestionMaster(body)
            this.setState({
                isDialogOpen: false
            });
            await this.getData();
        }
        catch (e: any) {
            if (e?.name === "AxiosError") {
                if (e?.response?.data?.detail?.includes("Active mapping exists") || e?.response?.data?.detail?.includes("combination already exists")) {
                    this.setState({ snackBar: { message: e?.response?.data?.detail, severity: 'warning', open: true, onClose: () => { } } });
                } else {
                    this.setState({ snackBar: { message: "Something went wrong!", severity: 'warning', open: true, onClose: () => { } } });
                }
            }
        }
        finally {
            this.setState({ loading: false });
        }
    };

    validateQuestionCode = (value: string) => {
        return /^[A-Z]{3}$/.test(value);
    };

    validateNumberList = (value: string) => {
        return /^\d+(,\d+)*$/.test(value);
    };
    onConfirmationDialog = async (): Promise<void> => {
        this.setState({ loading: true });
        try {
            if (this.state.confirmationDialog.isDelete) {
                await deleteQuestionMasterById(this.state.confirmationDialog.recordId);
            }
            else {
                await updateQuestionMasterStatus(this.state.confirmationDialog.recordId, this.state.confirmationDialog.activate);
            }
            await this.getData();
            this.setState({
                confirmationDialog: {
                    isOpen: false,
                    recordId: 0,
                    message: "",
                    activate: false,
                    isDelete: false
                }
            });
        } catch (e) {
            this.setState({ snackBar: { message: "Something went wrong!", severity: 'warning', open: true, onClose: () => { } } });
        }
        finally {
            this.setState({ loading: false });
        }
    }

    onSearch(e: any) {
        const searchText = e.target.value;
        const { copyData } = this.state;
        const response = copyData.filter((e: any) => e.QuestionCode.toLowerCase().includes(searchText.toLowerCase()));
        this.setState({ datas: response });

    }

    render() {
        const { loading, brokerMaster, selectedBrokerId, datas, isDialogOpen, dialogData, referenceBrokerMaster, snackBar, confirmationDialog } = this.state;
        const isFormValid =
            this.validateQuestionCode(dialogData.QuestionCode) &&
            this.validateNumberList(dialogData.LabelClassIds) &&
            this.validateNumberList(dialogData.FromAutos);
        return (
            <div style={{ fontSize: "12px" }}>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}
                <GridTable sx={{ height: '90vh' }} displaysidebar={this?.props?.displaysidebar}>
                    <p><b>LobSplit QuestionMaster</b></p><br />
                    <div style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "20px",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        width: "100%"
                    }}>
                        <div style={{ flex: "1 1 150px", maxWidth: "250px" }}>
                            <TextField
                                size="small"
                                placeholder="Search Question Code"
                                onChange={(e: any) => this.onSearch(e)}
                                sx={{
                                    '& .MuiInputBase-input::placeholder': {
                                        fontSize: '11px',
                                    },
                                    '& .MuiInputBase-input': {
                                        fontSize: '11px',
                                    },
                                    width: 200,
                                }}
                            />
                        </div>
                        <button
                            style={{
                                height: "25px",
                                padding: "0 20px",
                                backgroundColor: "#1976d2",
                                color: "#fff",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                                fontSize: "12px"
                            }}
                            onClick={() => {
                                this.getData();
                            }}
                        >
                            Search
                        </button>
                        <button
                            style={{
                                height: "25px",
                                padding: "0 20px",
                                backgroundColor: "#1976d2",
                                color: "#fff",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                                fontSize: "12px"
                            }}
                            onClick={() => {
                                this.setState({
                                    isDialogOpen: true, dialogData: {
                                        Id: 0,
                                        isAdd: true,
                                        QuestionCode: "",
                                        LabelClassIds: "",
                                        FromAutos: ""
                                    }
                                });
                            }}
                        >
                            Add
                        </button>
                    </div> <br />
                    <div>
                        <Paper sx={{ width: '100%', mb: 2, border: '0.5px solid #7a6e6e54', maxHeight: '60vh', marginTop: '15px' }}>
                            <TableContainer sx={{ maxHeight: 400, overflow: 'auto', paddingBottom: '5px' }}> {/* Enable scrolling */}
                                <Table stickyHeader sx={{ height: '50px' }} size="small">
                                    {/* Table Header */}
                                    <TableHead>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <TableCell
                                                    key={column.field}
                                                    sx={{
                                                        fontSize: '12px',
                                                        fontWeight: 'bold',
                                                        whiteSpace: 'nowrap',
                                                        backgroundColor: '#f5f5f5',
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    {column.headerName}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    {/* Table Body */}
                                    <TableBody>
                                        {datas && Array?.isArray(datas) && datas?.length > 0 &&
                                            datas?.map((row, rowIndex) => (
                                                <TableRow key={row.Id}>
                                                    {columns.map((column) => (
                                                        <TableCell
                                                            key={column.field}
                                                            sx={{
                                                                fontSize: '10px',
                                                                whiteSpace: 'normal',
                                                                wordWrap: 'break-word',
                                                                lineHeight: '1.5',
                                                            }}
                                                        >
                                                            {column.field === 'Action' ?
                                                                (
                                                                    <>
                                                                        {
                                                                            row.IsActive ?
                                                                                <Cancel fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                                    this.setState({
                                                                                        confirmationDialog: {
                                                                                            isOpen: true,
                                                                                            recordId: row.Id,
                                                                                            message: `Are you Sure you want to deactivate this record of Id: ${row?.Id}?`,
                                                                                            activate: false
                                                                                        }
                                                                                    });
                                                                                }} style={{ color: red[500] }} />
                                                                                :
                                                                                <CheckIcon fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                                    this.setState({
                                                                                        confirmationDialog: {
                                                                                            isOpen: true,
                                                                                            recordId: row.Id,
                                                                                            message: `Are you Sure you want to activate this record of Id: ${row?.Id}?`,
                                                                                            activate: true
                                                                                        }
                                                                                    });
                                                                                }} style={{ color: green[500] }} />
                                                                        }
                                                                        &nbsp;
                                                                        <Edit fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                            this.setState({
                                                                                isDialogOpen: true, dialogData: {
                                                                                    isAdd: false,
                                                                                    Id: row.Id,
                                                                                    QuestionCode: row.QuestionCode,
                                                                                    LabelClassIds: row.LabelClassIds,
                                                                                    FromAutos: row.FromAutos
                                                                                }
                                                                            });
                                                                        }} />
                                                                        {/* &nbsp; */}
                                                                        {/* <Delete fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                            this.setState({
                                                                                confirmationDialog: {
                                                                                    isOpen: true,
                                                                                    recordId: row?.Id,
                                                                                    message: `Are you Sure you want to delete this record of Id: ${row?.Id}?`,
                                                                                    activate: false,
                                                                                    isDelete: true
                                                                                }
                                                                            });
                                                                        }} /> */}
                                                                    </>
                                                                )
                                                                :
                                                                column.field === 'IsActive' ?
                                                                    (row[column.field] ? "Active" : "Inactive") :
                                                                    column.field === 'CreatedOn' && row[column.field] ? new Date(row[column.field]).toLocaleDateString() :
                                                                        row[column.field]
                                                            }
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </div>
                    <div>
                        <Dialog open={isDialogOpen} onClose={(e) => { }} fullWidth maxWidth="md">
                            <DialogTitle>{dialogData?.isAdd ? "Add New Question" : "Edit Question"}</DialogTitle>
                            <DialogContent>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                    <p>Question Code</p>
                                    <TextField
                                        size="small"
                                        placeholder="Question Code"
                                        value={dialogData.QuestionCode}
                                        onChange={(e) => {
    const value = e.target.value
        .toUpperCase()
        .replace(/[^A-Z]/g, "")
        .slice(0, 3);

    dialogData.QuestionCode = value;
    this.setState({ dialogData });
}}
                                        sx={{
                                            '& .MuiInputBase-input::placeholder': {
                                                fontSize: '11px',
                                            },
                                            '& .MuiInputBase-input': {
                                                fontSize: '11px',
                                            },
                                            width: '100%',
                                        }}
                                    />
                                    <p>Label ClassIds</p>
                                    <TextField
                                        size="small"
                                        placeholder="Label ClassIds"
                                        value={dialogData.LabelClassIds}
                                        onChange={(e) => {
    const value = e.target.value
        .replace(/[^0-9,]/g, "")
        .replace(/,{2,}/g, ",")
        .replace(/^,/, "");

    dialogData.LabelClassIds = value;
    this.setState({ dialogData });
}}
                                        sx={{
                                            '& .MuiInputBase-input::placeholder': {
                                                fontSize: '11px',
                                            },
                                            '& .MuiInputBase-input': {
                                                fontSize: '11px',
                                            },
                                            width: '100%',
                                        }}
                                    />
                                    <p>From Autos</p>
                                    <TextField
                                        size="small"
                                        placeholder="From Autos"
                                        value={dialogData.FromAutos}
                                        onChange={(e) => {
    const value = e.target.value
        .replace(/[^0-9,]/g, "")
        .replace(/,{2,}/g, ",")
        .replace(/^,/, "");

    dialogData.FromAutos = value;
    this.setState({ dialogData });
}}
                                        sx={{
                                            '& .MuiInputBase-input::placeholder': {
                                                fontSize: '11px',
                                            },
                                            '& .MuiInputBase-input': {
                                                fontSize: '11px',
                                            },
                                            width: '100%',
                                        }}
                                    />
                                </div>
                            </DialogContent>
                            <DialogActions
    sx={{
        px: 3,
        py: 2,
        justifyContent: "flex-end",
        gap: 1,
    }}
>
    <Button
        onClick={this.handleDialogClose}
        sx={{
            color: "#1976d2",
            fontWeight: 500,
            fontSize: "15px",
            textTransform: "uppercase",
            minWidth: "90px",
            "&:hover": {
                backgroundColor: "rgba(25,118,210,0.08)",
            },
        }}
    >
        Cancel
    </Button>

    <Button
        variant="contained"
        onClick={this.handleDialogConfirm}
        disabled={!isFormValid}
        sx={{
            backgroundColor: "#1976d2",
            color: "#fff",
            fontWeight: 600,
            fontSize: "15px",
            textTransform: "uppercase",
            minWidth: "120px",
            height: "42px",
            borderRadius: "4px",
            boxShadow: "0px 3px 6px rgba(0,0,0,0.3)",
            "&:hover": {
                backgroundColor: "#1565c0",
                boxShadow: "0px 5px 10px rgba(0,0,0,0.35)",
            },
            "&.Mui-disabled": {
                backgroundColor: "#bdbdbd",
                color: "#fff",
            },
        }}
    >
        Submit
    </Button>
</DialogActions>
                        </Dialog>
                    </div>
                    <div>
                        <SnackBarComponent open={snackBar.open} message={snackBar.message} severity={snackBar.severity} onClose={() => {
                            this.setState({
                                snackBar: {
                                    ...this.state.snackBar,
                                    open: false,
                                    message: ''
                                }
                            });
                        }} />
                        <ConfirmationDialogComponent open={confirmationDialog.isOpen} message={confirmationDialog.message} onConfirm={() => { this.onConfirmationDialog() }} onClose={() => {
                            this.setState({
                                confirmationDialog: {
                                    isOpen: false,
                                    recordId: 0,
                                    message: "",
                                    activate: false,
                                    isDelete: false
                                }
                            });
                        }} />
                    </div>
                </GridTable>
            </div>
        );
    }
}

export default QuestionMaster;